import { CBM, CONDITIONAL, LOGIC, MANAGE_RULES, MATH } from "Pages/GMS/ISR/ISRConstants";
import { SearchIcon, XIcon } from "assests/GmsIcons";
import React, { useContext, useEffect, useState } from "react";
import {
  TConnector,
  TField,
  TIndexState,
  TProductCategory,
  TSubmodel,
  TUpsertISRProjectDataModelsInput,
} from "../model";
import CBMRule from "../../Rules/CBMRule";
import MathRuleComponent from "Pages/GMS/ISR/Components/Rules/MathRuleComponent";
import ConditionalRuleComponent from "Pages/GMS/ISR/Components/Rules/ConditionalRuleComponent";
import LogicRuleComponent from "Pages/GMS/ISR/Components/Rules/LogicRuleComponent";
import Search from "Pages/GMS/Search";
import SidePanelComponent from "Pages/GMS/ISR/Components/RuleComponents/SidePanelComponent";
import { SB3RuleContext } from "Pages/GMS/ISR/Components/Rules/SB3RuleContext";
import { toast } from "react-toastify";

type TManageRulesDialogProps = {
  showRulesMenu: boolean;
  setShowRulesMenu: React.Dispatch<React.SetStateAction<boolean>>;
  selectedItem: TField | TSubmodel | TProductCategory | TConnector | null;
  setUserProjectDataModels: React.Dispatch<
    React.SetStateAction<TUpsertISRProjectDataModelsInput>
  >;
  userProjectDataModels: TUpsertISRProjectDataModelsInput;
  indexInfo?: TIndexState;
  editId?: string|undefined|null;
  ruleType?: string|undefined|null;
  createISRProject:(isRuleUpdate: boolean)=>void;
  featureType: string
};


const ManageRulesDialog = ({
  showRulesMenu,
  setShowRulesMenu,
  selectedItem,
  userProjectDataModels,
  setUserProjectDataModels,
  indexInfo,
  editId,
  ruleType,
  createISRProject,
  featureType
}: TManageRulesDialogProps) => {
  const { updateModelData, showPickPanel, handleSaveRule, logicRule, handleUpdateRule, resetLogicRule } = useContext(SB3RuleContext)

  useEffect(() => {
    updateModelData(userProjectDataModels?.project)
  }, [userProjectDataModels])

  const toggleMenu = () => {
    setShowRulesMenu(!showRulesMenu);
  };

  const overlayClasses =
    "tw-absolute tw-inset-0 tw-bg-black tw-opacity-50 tw-z-40 tw-h-full tw-w-full";
  const menuClasses = showRulesMenu
    ? `tw-absolute tw-top-0 tw-right-0 tw-h-full tw-max-h-full tw-overflow-auto ${ruleType === 'Logic' && showPickPanel ? "tw-w-[84%]" : "tw-w-[65%]"}  tw-bg-white tw-z-50  tw-shadow-lg`
    : "tw-hidden";

  const handleSaveOrUpdate = () => {
    if (logicRule?.name) {
      if (logicRule?.rule_type === LOGIC.toLocaleLowerCase() && logicRule?.id) {
        handleUpdateRule()
      } else {
        handleSaveRule(userProjectDataModels?.project?.id)
    }
    }
    else toast.info("Rule name is mandatory")
  }

  return (
    <div className="tw-h-[calc(100vh-60px)] tw-fixed tw-top-0 tw-left-0 tw-w-full tw-z-40 tw-mt-16 ">
      <div className={overlayClasses} onClick={() => toggleMenu()} />
      <div className={menuClasses}>
        <div
          className={`tw-flex tw-justify-between tw-items-center tw-border-b tw-pb-2 tw-pt-4 tw-pr-2 tw-pl-2 tw-sticky tw-top-0 tw-bg-white tw-z-10`}
        >
          <h2 className={`tw-text-[#091E42] tw-font-bold tw-text-sm`}>
            {ruleType} Rule
          </h2>
          <div className="tw-flex tw-items-center tw-gap-5">
            <button
              onClick={() => { resetLogicRule(); toggleMenu() }}
              className={`  tw-rounded  tw-bg-shades-of-grey-0 tw-text-primary tw-flex tw-flex-row tw-items-center tw-justify-center tw-h-7 tw-py-1 tw-px-2.5 tw-gap-[4px] tw-text-sm  tw-border-[1px] tw-border-solid tw-border-primary`}
            >
              Cancel
            </button>
            {ruleType === LOGIC ? <button
              onClick={() => { return ruleType === LOGIC ? handleSaveOrUpdate() : toggleMenu() }}
              className={`  tw-rounded  tw-bg-blue-800 tw-text-white tw-flex tw-flex-row tw-items-center tw-justify-center tw-h-7 tw-py-1 tw-px-2.5 tw-gap-[4px] tw-text-sm  tw-border-[1px] tw-border-solid tw-border-primary`}
            >
              {logicRule?.id ? "Update" : "Done"}
            </button> : null}
          </div>
        </div>
        {/* <RulesAddEditManage ruleId={'0'} rule_version={'Live'} /> */}
        <div>
          {ruleType === MATH && (
            <MathRuleComponent
              selectedItem={selectedItem}
              userProjectDataModels={userProjectDataModels}
              setUserProjectDataModels={setUserProjectDataModels}
              indexInfo={indexInfo}
              editId={editId}
              ruleType={ruleType}
              toggleMenu={toggleMenu}
              createISRProject={createISRProject}
            />
          )}
          {ruleType === CBM && (
            <CBMRule
              selectedItem={selectedItem}
              userProjectDataModels={userProjectDataModels}
              setUserProjectDataModels={setUserProjectDataModels}
              indexInfo={indexInfo}
              editId={editId}
              ruleType={ruleType}
              toggleMenu={toggleMenu}
              createISRProject={createISRProject}
            />
          )}
          {ruleType === CONDITIONAL && (
            <ConditionalRuleComponent
              selectedItem={selectedItem}
              userProjectDataModels={userProjectDataModels}
              setUserProjectDataModels={setUserProjectDataModels}
              indexInfo={indexInfo}
              editId={editId}
              ruleType={ruleType}
              toggleMenu={toggleMenu}
              createISRProject={createISRProject}
              featureType={featureType}
          />
          )}

          {ruleType === LOGIC && (
            <div className="tw-flex  tw-bg-gray-100 tw-border tw-border-zinc-300">
              {showPickPanel &&
                <SidePanelComponent />
              }

              <LogicRuleComponent />
            </div>
          )}

        </div>
      </div>
    </div>
  );
};

export default ManageRulesDialog;
